interface PriceInputProps {
  value: number;
  onChange: (value: number) => void;
  cost?: number;
  label?: string;
  minMarginPct?: number;
}

export function PriceInput({ value, onChange, cost, label = 'Retail Price', minMarginPct = 30 }: PriceInputProps) {
  const margin = cost != null ? value - cost : 0;
  const marginPct = cost != null && cost > 0 ? (margin / cost) * 100 : 0;
  const meetsMargin = marginPct >= minMarginPct;

  return (
    <div className="form-group">
      <label className="form-label">{label}</label>
      <div className="price-input-row">
        <div style={{ position: 'relative', flex: '0 0 100px' }}>
          <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'var(--ink-faint)', fontSize: '0.85rem' }}>$</span>
          <input
            className="form-input"
            type="number"
            step="0.01"
            min="0"
            value={value}
            onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
            style={{ paddingLeft: '24px' }}
          />
        </div>
        {cost != null && (
          <div className={`price-margin ${meetsMargin ? 'price-margin--positive' : 'price-margin--negative'}`}>
            <span>Cost: ${cost.toFixed(2)}</span>
            <span style={{ marginLeft: '8px' }}>
              Margin: ${margin.toFixed(2)} ({marginPct.toFixed(0)}%)
            </span>
            {!meetsMargin && (
              <span style={{ marginLeft: '8px', color: 'var(--red)' }}>
                below {minMarginPct}% minimum
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
